import React from "react";
import cn from "classnames";
import { NavLink } from "react-router-dom";

import Button from "./common/Button";
import { useModal } from "../hooks/modal";
import { useMessage } from "../hooks/message";
import { useDeleteRequest } from "../hooks/request";
import { checkPermission as cp } from "../utils/auth";
import { MANTHLY_INCOME_QUARTERLY_DETAIL } from "../urls";
import Progress from "./componentsFinance/common/Progress";
import ManthlyIncomeQuarterlyUpdate from "./ManthlyIncomeQuarterlyUpdate";

export default function ManthlyIncomeQuarterlyItem({ reportItem, index, onUpdate, onDelete }) {
  const [showMessage] = useMessage();
  const rotationDelete = useDeleteRequest({ url: MANTHLY_INCOME_QUARTERLY_DETAIL.replace("{id}", reportItem ? reportItem.id : "") });

  const [showUpdateModal, hideUpdateModal] = useModal(
    <ManthlyIncomeQuarterlyUpdate
      report={reportItem}
      onUpdate={() => {
        onUpdate();
        hideUpdateModal();
      }}
      onCancel={() => hideUpdateModal()}
    />,
  );

  async function deleteReport() {
    if (!global.confirm("Вы действительно хотите удалить?")) return;

    const { error } = await rotationDelete.request();
    if (error) {
      showMessage(error.data.detail, "is-danger");
      return;
    }
    onDelete();
  }

  return (
    <tr className="">
      <td className="has-text-centered">{index + 1}</td>
      <td className={cn("mt-3 is-centered")}>
        <NavLink className="" to={`/manthly/income-quarterly-item/${reportItem.id}`}>
          <span className="tag is-info is-light is-medium">{reportItem.quarter}</span>
        </NavLink>
      </td>
      <td className={cn("has-text-centered")}>{reportItem.clientCount}</td>
      <td className={cn("has-text-centered")}>{reportItem.taskCount}</td>
      <td className="has-text-centered">{reportItem.taxCount}</td>
      <td className="has-text-centered">
        <span className="tag is-info is-light mb-2 is-medium">Ҳисоботлар жўнатилиши </span> <br />
        <span className="tag is-success is-light mb-2 is-medium">Солиқлар тўланиши </span> <br />
      </td>

      <td className="has-text-centered">
        <div style={{ width: 150 }} className="mt-2">
          <Progress value={reportItem.progress} text={`${reportItem.progress} %`} /> <br />
          <Progress value={reportItem.progressTax} text={`${reportItem.progressTax} %`} /> <br />
        </div>
      </td>
      {cp("staff.delete_employee") ? (
        <td className="has-text-centered">
          <div className="is-flex">
            <Button className="is-outlined is-danger mb-2 is-small mr-2" icon="ion-md-trash" onClick={deleteReport} />
            <Button className="is-outlined is-success is-small" icon="ion-md-create" onClick={showUpdateModal} />
          </div>
        </td>
      ) : (
        <td className="has-text-centered" />
      )}
    </tr>
  );
}
